module.exports = __webpack_public_path__ + "static/media/gr.ca97f001.png";